import Splide from '@splidejs/splide';

function productsCarousel() {
    const carouselMediaCards = document.querySelectorAll('.splide--carousel_products');

    carouselMediaCards.forEach((item) => {
        const splide = new Splide(item, {
            drag: true,
            autoWidth: false,
            pagination: true,
            arrows: false,
            type: 'loop',
            focus: 'center',
            perPage: 4,
            perMove: 1,
            padding: { left: '0', right: 200 },
            gap: 20,
            speed: 600, // Velocidad de transición consistente
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // Easing suave
            rewind: false, // Evita recalculo al volver
            waitForTransition: false, // NO espera a que termine la transición
            updateOnMove: false, // NO actualiza durante movimiento
            trimSpace: false, // NO recorta espacio extra
            breakpoints: {
                1440: {
                    perPage: 3,
                    perMove: 1,
                    padding: { left: 0, right: 250 },
                    gap: 15
                },
                1024: {
                    perPage: 3,
                    perMove: 1,
                    padding: { left: 0, right: 150 },
                    gap: 15
                },
                768: {
                    perPage: 2,
                    perMove: 1,
                    padding: { left: 0, right: '25vw' },
                    gap: 15
                },
                576: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 0, right: '30vw' },
                    gap: 15
                }
            }
        });

        splide.mount();

    });
}

export default productsCarousel;